import { render } from "./FormatStrikethrough.vue?vue&type=template&id=d749d694"
import script from "./FormatStrikethrough.vue?vue&type=script&lang=js"
export * from "./FormatStrikethrough.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__